$(function() {
  function calculateTotals() {
    let requiredAmountTotal = 0;
    let askAmountTotal = 0;
    
    $('#social_aid_request_costs .nested-fields').each(function() {
      const requiredAmount = parseFloat($(this).find('input[id$="_required_amount"]').val()) || 0;
      const askAmount = parseFloat($(this).find('input[id$="_ask_amount"]').val()) || 0;
      
      requiredAmountTotal += requiredAmount;
      askAmountTotal += askAmount;
    });
    
    $('#required_amount_total').val(requiredAmountTotal.toFixed(2));
    $('#ask_amount_total').val(askAmountTotal.toFixed(2));
  }
  
  calculateTotals();
  
  $(document).on('input', 'input[id$="_required_amount"], input[id$="_ask_amount"]', function() {
    calculateTotals();
  });
  
  $(document).on('cocoon:after-insert', function() {
    calculateTotals();
  });
  
  $(document).on('cocoon:after-remove', function() {
    calculateTotals();
  });
  
  $(document).on('click', '.remove_fields, .button-avaka.red', function() {
    setTimeout(calculateTotals, 50);
  });
});
